'use client';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { motion } from 'motion/react';
import type { ItemsGridProps } from './types';
import Background from '../components/Background';
import StaggerGroup from '@/components/animations/StaggerGroup';
import { staggerChild } from '@/components/animations/tokens';

function ItemsGrid({ title, items, backgroundColor = 'white' }: ItemsGridProps) {
  return (
    <Background backgroundColor={backgroundColor}>
      <Container
        maxWidth='lg'
        sx={{
          maxWidth: {
            lg: '1280px', // Explicitly set for laptop screens
          },
          '@media (min-width: 2000px)': {
            maxWidth: '1600px', // Only for very large screens
          },
          py: 2,
        }}
      >
        <Typography
          variant='h4'
          sx={{
            color: 'text.primary',
            fontWeight: 'bold',
            textAlign: 'center',
            mb: { xs: 1, md: 2 },
          }}
        >
          {title}
        </Typography>

        <StaggerGroup>
          <Grid container spacing={{ xs: 1, md: 3 }} sx={{ width: '100%' }} columns={12}>
            {items?.map((item, index) => (
              <Grid
                key={index}
                component={motion.article}
                variants={staggerChild}
                size={{ xs: 12, sm: 6, md: 4 }}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  variant='h5'
                  sx={{
                    color: 'primary.main',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    mb: 1,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    color: 'text.primary',
                    textAlign: 'center',
                    flexGrow: 1,
                  }}
                >
                  {item.description}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </StaggerGroup>
      </Container>
    </Background>
  );
}

export { ItemsGrid, type ItemsGridProps };
